import React, { FC } from "react";
import { createUseStyles } from "react-jss";
import InstagramObject from "Components/InstagramObject";
import styles from "./styles";

export interface MediaObjectProps {
  img: any;
  children: any;
  alt?: string;
  style?: {};
  onClick?: (e: any) => void;
  media?: any;
}

export const MediaObject: FC<MediaObjectProps> = (props: MediaObjectProps) => {
  const useStyles = createUseStyles(styles);

  const classes = useStyles({ ...props });
  const { img, alt, children, onClick, style, media } = props;

  return (
    <button
      className={classes.container}
      onClick={onClick}
      tabIndex={0}
      type="button"
      data-testid="mediaObject"
    >
      {media && media[0]?.network === "instagram" ? (
        <InstagramObject
          embedId={media[0].videoid ?? media[0].url}
          onClick={onClick}
          alt={alt || "Media Content"}
          className={classes.media}
          top={-55}
          left={media[0].videoid ? -65 : 0}
          width="100%"
          height="100%"
          iframeWidth={media[0].videoid ? "250%" : "150%"}
          iframeHeight="170%"
          style={{ borderRadius: "8px" }}
        />
      ) : (
        <img
          src={img}
          alt={alt || "Media Content"}
          className={classes.media}
          style={style}
          data-testid="image"
        />
      )}
      <div className={classes.mediaIcon}>{...children}</div>
    </button>
  );
};
try {
    // @ts-ignore
    MediaObject.displayName = "MediaObject";
    // @ts-ignore
    MediaObject.__docgenInfo = { "description": "", "displayName": "MediaObject", "props": { "img": { "defaultValue": null, "description": "", "name": "img", "required": true, "type": { "name": "any" } }, "alt": { "defaultValue": null, "description": "", "name": "alt", "required": false, "type": { "name": "string" } }, "style": { "defaultValue": null, "description": "", "name": "style", "required": false, "type": { "name": "{}" } }, "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": false, "type": { "name": "(e: any) => void" } }, "media": { "defaultValue": null, "description": "", "name": "media", "required": false, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/MediaObject/MediaObject.tsx#MediaObject"] = { docgenInfo: MediaObject.__docgenInfo, name: "MediaObject", path: "src/shared/components/MediaObject/MediaObject.tsx#MediaObject" };
}
catch (__react_docgen_typescript_loader_error) { }